import Vue from 'vue';
import Vuex from 'vuex';
import createPersist from 'vuex-localstorage'
import SyncQueue from './modules/SyncQueue'
import RoomsCache from './modules/RoomsCache'
import TeamsCache from './modules/TeamsCache'
Vue.use(Vuex)

const store = {
  install: function (Vue, options) {
    // Install Sync Queue Store
    Vue.syncStore = new Vuex.Store({
      plugins: [createPersist({
        namespace: 'queue-store',
        initialState: SyncQueue.state
      })],
      modules: {
        SyncQueue
      }
    });

    // Install Room Store
    Vue.roomsStore = new Vuex.Store({
      plugins: [createPersist({
        namespace: 'rooms-store',
        initialState: RoomsCache.state
      })],
      modules: {
        RoomsCache
      }
    });

    // Install Room Store
    Vue.teamsStore = new Vuex.Store({
      plugins: [createPersist({
        namespace: 'teams-store',
        initialState: TeamsCache.state
      })],
      modules: {
        TeamsCache
      }
    });

    // Clear Cache Stores if Local Storage Uses Old Schema
    if (Vue.roomsStore.state.RoomsCache.rooms.constructor === Array || Vue.roomsStore.state.RoomsCache.inventory.constructor === Array) {
      Vue.roomsStore.dispatch('clearCache');
      Vue.syncStore.dispatch('clearQueue');
    }
  }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/Store.js